//CURRENTLY JUST KEEPS TRACK OF IF USER LOGGED IN AND TO DISPLAY OR NOT

export const TOGGLE_POPUP = 'TOGGLE_POPUP';
export const togglePopup = value => ({
    type: TOGGLE_POPUP,
    value,
});
